import React, { useState } from 'react';
import { Modal, Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword } from './store/User.action';
import Loader from '../../Components/Utility/Loader/Loader';

function ChangePasswordModel(props) {
  const { show, title, toggle } = props;
  const [showLoader, setShowLoader] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    defaultValues: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
  });
  const dispatch = useDispatch();
  const {
    UserDetails: {
      userInfo: { email },
    },
  } = useSelector((state) => state);
  const { t } = useTranslation('common');

  const validatePassRegex = (val) => {
    const regex = /^(?=.*[A-Z])(?=.*[^a-zA-Z]).+$/;
    return regex.exec(val);
  };

  const errorMsg = () => {
    return t('CHANGE_PASSWORD_MODAL.MESSAGE');
  };
  const validate = {
    validateCnfPass: (val) => {
      if (!validatePassRegex(val)) {
        return errorMsg();
      }
      if (!val?.trim()) {
        return t('CHANGE_PASSWORD_MODAL.CONFIRM_PASSWORD_REQUIRED');
      }
      if (val !== watch('newPassword')) return t('CHANGE_PASSWORD_MODAL.PASSWORD_MISMATCH');
      return null;
    },
    validateNewPass: (val) => {
      if (!validatePassRegex(val)) {
        return errorMsg();
      }
      if (!val?.trim()) {
        return t('CHANGE_PASSWORD_MODAL.NEW_PASSWORD_REQUIRED');
      }
      return null;
    },
    validateCurrPass: (val) => {
      if (!validatePassRegex(val)) {
        return errorMsg();
      }
      if (!val?.trim()) {
        return t('CHANGE_PASSWORD_MODAL.CURRENT_PASSWORD_REQUIRED');
      }
      return null;
    },
  };
  const onSubmit = async (val) => {
    const reqObj = { ...val, email };
    setShowLoader(true);
    const res = await dispatch(changePassword(reqObj, t));
    if (res) toggle();
    setShowLoader(false);
  };

  return (
    <Modal
      size="lg"
      show={show}
      toggle={toggle}
      animation
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      className="common-custom-modal modal-medium"
    >
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header className="modal-header-custom">
          <Modal.Title id="contained-modal-title-vcenter">
            <span className="confirm-title">{title}</span>
          </Modal.Title>
          <span className="icon-close cursor-pointer ml-auto" onClick={toggle} />
        </Modal.Header>
        <Modal.Body>
          {showLoader ? (
            <Loader />
          ) : (
            <div className="modal-inner-data">
              <Row>
                <Col md={6} sm={6}>
                  <div className="common-input-control d-flex align-items-center mb-0 ">
                    <span className="fix-icon icon-lock mr-16 " />
                    <div>
                      <p className="field-name mr-2 ">
                        {t('CHANGE_PASSWORD_MODAL.CURRENT_PASSWORD')}
                        <span className="asterisk">*</span>
                      </p>
                      <Form.Control
                        className={watch('currentPassword') && 'data-filled form-control p-0'}
                        {...register('currentPassword', {
                          required: t('CHANGE_PASSWORD_MODAL.CURRENT_PASSWORD_REQUIRED'),
                          validate: validate.validateCurrPass,
                        })}
                        type="password"
                        placeholder={t('COMMON_LABEL.ENTER_PASSWORD')}
                      />
                      {errors?.currentPassword?.message && <Form.Text className="text-danger">{errors?.currentPassword?.message}</Form.Text>}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mt-16">
                <Col md={6} sm={6}>
                  <div className="common-input-control d-flex align-items-center mb-0 ">
                    <span className="fix-icon icon-lock mr-16" />
                    <div>
                      <p className="field-name mr-2 ">
                        {t('CHANGE_PASSWORD_MODAL.NEW_PASSWORD')}
                        <span className="asterisk">*</span>
                      </p>
                      <Form.Control
                        className={watch('newPassword') && 'data-filled form-control p-0'}
                        {...register('newPassword', { required: t('CHANGE_PASSWORD_MODAL.NEW_PASSWORD_REQUIRED'), validate: validate.validateNewPass })}
                        type="password"
                        placeholder={t('COMMON_LABEL.ENTER_NEW_PASSWORD')}
                      />
                      {errors?.newPassword?.message && <Form.Text className="text-danger">{errors?.newPassword?.message}</Form.Text>}
                    </div>
                  </div>
                </Col>
                <Col md={6} sm={6}>
                  <div className="common-input-control d-flex align-items-center mb-0 ">
                    <span className="fix-icon icon-lock mr-16 " />
                    <div>
                      <p className="field-name mr-2">
                        {t('CHANGE_PASSWORD_MODAL.CONFIRM_NEW_PASSWORD')}
                        <span className="asterisk">*</span>
                      </p>
                      <Form.Control
                        className={watch('confirmPassword') && 'data-filled form-control p-0'}
                        {...register('confirmPassword', {
                          required: t('CHANGE_PASSWORD_MODAL.CONFIRM_PASSWORD_REQUIRED'),
                          validate: validate.validateCnfPass,
                        })}
                        type="password"
                        placeholder={t('COMMON_LABEL.ENTER_NEW_PASSWORD')}
                      />
                      {errors?.confirmPassword?.message && <Form.Text className="text-danger">{errors?.confirmPassword?.message}</Form.Text>}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <div className="common-model-footer">
            <button type="submit" className="btn p-0">
              <i className="icon-Tick-1 f-24" />{' '}
            </button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
}

export default ChangePasswordModel;
